var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3727 2C20.3759 2 22 3.62407 22 5.62768V18.3723C22 20.3759 20.3759 22 18.3727 22H5.62735C3.62413 22 2 20.3759 2 18.3723V5.62768C2 3.62407 3.62413 2 5.62735 2H18.3727ZM20.6276 18.3723V5.62768C20.6276 4.38197 19.6182 3.37261 18.3727 3.37261H5.62735C4.38182 3.37261 3.37241 4.38197 3.37241 5.62768V18.3723C3.37241 19.618 4.38182 20.6274 5.62735 20.6274H18.3727C19.6182 20.6274 20.6276 19.618 20.6276 18.3723ZM11.9995 8.56772C12.6763 8.56772 13.225 8.01906 13.225 7.34224C13.225 6.66542 12.6763 6.11675 11.9995 6.11675C11.3227 6.11675 10.774 6.66542 10.774 7.34224C10.774 8.01906 11.3227 8.56772 11.9995 8.56772ZM12.6368 18.2734C12.6907 18.2734 12.7348 18.2295 12.7348 18.1753V10.1541C12.7348 10.0999 12.6907 10.056 12.6368 10.056H11.3623C11.3083 10.056 11.2642 10.0999 11.2642 10.1541V18.1753C11.2642 18.2295 11.3083 18.2734 11.3623 18.2734H12.6368Z",
    fill: "#090A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.4b40eab6012f84aa7cfd88e7aaf88683.svg";
export { ForwardRef as ReactComponent };